import { render } from "./IconObservation.vue?vue&type=template&id=270b7874&lang=html"
import script from "./IconObservation.vue?vue&type=script&lang=js"
export * from "./IconObservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__